import styled from '@emotion/styled';
import {
  Button,
  type ButtonProps,
  IconButton,
  type IconButtonProps,
  Tooltip,
  useMediaQuery,
} from '@mui/material';
import { ExitToApp as LeaveIcon } from '@mui/icons-material';
import FormattedMessageWithChallengeNaming from '@/components/FormattedMessageWithChallengeNaming';

const StyledLeaveButton = styled(Button)({
  marginTop: 14,
  marginLeft: 6,
  height: 36,
});

const StyledLeaveIconButton = styled(IconButton)({
  marginTop: 12,
  marginLeft: 6,
});

type LeaveButtonProps = Omit<
  IconButtonProps | ButtonProps,
  'color' | 'children'
>;

const LeaveButton = (props: LeaveButtonProps) => {
  const shouldUseIconButton = useMediaQuery('(max-width: 1200px)');

  if (shouldUseIconButton) {
    return (
      <Tooltip
        title={
          <FormattedMessageWithChallengeNaming id="portfolio.challenge.sharing.leave.button" />
        }
      >
        <StyledLeaveIconButton color="error" {...props}>
          <LeaveIcon />
        </StyledLeaveIconButton>
      </Tooltip>
    );
  }

  return (
    <StyledLeaveButton color="error" startIcon={<LeaveIcon />} {...props}>
      <FormattedMessageWithChallengeNaming id="portfolio.challenge.sharing.leave.button" />
    </StyledLeaveButton>
  );
};

export default LeaveButton;
